import { Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'

interface AuthFormPropsType {
  onSubmit?: any
  children: React.ReactNode
  className?: string
  flexProps?: FlexProps
}

const AuthForm: React.FC<AuthFormPropsType> = ({
  onSubmit,
  children,
  className,
  flexProps
}) => {
  const classN = className ?? 'mx-auto sm:w-8/12 md:w-6/12 lg:w-4/12'
  return (
    <form className={classN} onSubmit={onSubmit}>
      <Flex flexDirection={'column'} w={'100%'} gap={7} {...flexProps}>
        {children}
      </Flex>
    </form>
  )
}

export default AuthForm
